import {cn} from '@tempmee/core'
import {type HTMLAttributes, forwardRef} from 'react'
import {TableSectionContext} from './context'

export interface TableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {}

/**
 * TableBody (v3, MUI-aligned) — renders `<tbody>` and marks its cells as body
 * cells. Mirrors `@mui/material/TableBody`: the last row's bottom divider is
 * dropped (`tr:last-child td/th`) so the table doesn't end on a rule.
 */
export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(
  ({className, ...props}, ref) => (
    <TableSectionContext.Provider value="body">
      <tbody
        ref={ref}
        className={cn('[&_tr:last-child_td]:border-b-0 [&_tr:last-child_th]:border-b-0', className)}
        {...props}
      />
    </TableSectionContext.Provider>
  ),
)
TableBody.displayName = 'TableBody'
